import * as React from "react";
import {Box, Skeleton, Typography} from "@mui/material";

export default function TopDebtorsHeader({tierLabel, customersCount, tierTotal, tierColor, loading}) {
    return (
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 2, marginBottom: 1}}>
            <Box component="span"
                 sx={(theme) => ({
                     display: 'inline-block', fontSize: 12, fontWeight: 700, py: 0.5, px: 1.5,
                     borderRadius: '9999px', backgroundColor: tierColor, color: theme.palette.common.white,
                 })}>
                {tierLabel} — Top 10
            </Box>
            {loading
                ? <Skeleton variant="text" width={160} height={20}/>
                : <Typography variant="body2" color="text.secondary">
                    {customersCount} clientes · {tierTotal} en este tramo
                </Typography>}
        </Box>
    );
}
